export const getImageStyles = img =>
    img && img.attributes && img.attributes.variants && img.attributes.variants['landscape-crop']
        ? {
              backgroundImage: `url('${img.attributes.variants['landscape-crop'].url}')`,
          }
        : {};

export const formatDateOptions = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
};

export const getDublicateListingParams = l => {
    const dublicateParams = {
        publicData: l.attributes.publicData || {},
        privateData: {
            dublicateOf: l.id.uuid,
        },
    };
    const insertIfNonEmpty = key => {
        const value = l.attributes[key];
        if (value) {
            dublicateParams[key] = value;
        }
    };

    ['title', 'price', 'geolocation', 'description'].forEach(insertIfNonEmpty);

    return dublicateParams;
};
